import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_PROSPECTS_TO_WATCH_DATA,
  SET_PROSPECTS_TO_WATCH_DATA,
  FETCH_PROSPECTS_TO_WATCH_DATA_ERROR,
} from '../constants';

const prospectsToWatch = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_PROSPECTS_TO_WATCH_DATA),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/prospects?${`&since=${
          encodeURIComponent(state$.value.home.sinceDate)
          }&until=${encodeURIComponent(
            state$.value.home.untilDate
          )}`}&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_PROSPECTS_TO_WATCH_DATA,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_PROSPECTS_TO_WATCH_DATA_ERROR,
            error,
          })
        )
      )
    )
  );

export default prospectsToWatch;
